import script from "./DepositsByClickId.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositsByClickId.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__